// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetInvoicePaymentHistoryApiParameter } from "@eisinc/App/Store/Reducers";
import { get } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface InvoicePaymentHistoryModel {
    id: string;
    billTo: string;
    clearingDate: string;
    clearingDoc: string;
    accountingDoc: string;
    accountDocLineNumber: string;
    documentDate: string;
    documentCurrencyCode: string;
    docType: string;
    debitCredit: string;
    documentCurrency: number;
    itemText: string;
    billingDoc: string;
    poReference: string;
}

export interface InvoicePaymentHistoryCollectionModel {
    clearedDocumentList: InvoicePaymentHistoryModel[];
    timeFrameAvailability: string;
    pagination: PaginationModel | null;
}

export const invoicePaymentHistoryApi = "/api/custom/invoicePayment/getClearedDocument";

export async function xngGetInvoicePaymentHistory(parameter: GetInvoicePaymentHistoryApiParameter) {
    const InvoicePaymentHistory = await get<InvoicePaymentHistoryCollectionModel>(invoicePaymentHistoryApi, parameter);
    return InvoicePaymentHistory;
}
